import {AttachmentCreate, AttachmentResource} from '@/interfaces';
import {CrudApiAbstract} from '@/api/CrudApiAbstract';
import {ResourceType} from '@/enums';

export class AttachmentApi extends CrudApiAbstract<
  AttachmentResource,
  AttachmentCreate
> {
  public constructor() {
    super(`${ResourceType.Attachment}s`);
  }
}
